import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * The progress panel shown in place of a list while a search or filter resolves, matching the
 * collection screen's treatment: the AI mascot above a creeping bar. Render it behind an `*ngIf`
 * on the screen's own in-flight flag - the bar animates while mounted and stops on destroy.
 */
@Component({
  selector: 'cygov-search-progress',
  templateUrl: './search-progress.component.html',
  styleUrls: ['./search-progress.component.scss'],
  standalone: false,
})
export class SearchProgressComponent implements OnInit, OnDestroy {
  progress = 0;
  // stable references so the OnPush progress bar is not handed new inputs every cycle
  readonly postFill = ['var(--color-btn-primary)'];
  readonly preFill = 'var(--color-progress-bar-bg)';

  private progressInterval: ReturnType<typeof setInterval>;
  private readonly PROGRESS_STEP = 10;
  private readonly PROGRESS_TICK_MS = 200;
  // the bar waits below the end until the results land, so it can never finish before the data
  private readonly PROGRESS_CEILING = 90;

  ngOnInit(): void {
    this.progressInterval = setInterval(() => {
      this.progress = Math.min(this.progress + this.PROGRESS_STEP, this.PROGRESS_CEILING);
    }, this.PROGRESS_TICK_MS);
  }

  ngOnDestroy(): void {
    clearInterval(this.progressInterval);
  }
}
